var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mt-2"},[(_vm.series)?_c('apexchart',{attrs:{"type":"area","height":"230","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }